// extracted by mini-css-extract-plugin
export default {"input":"signin_input__ugDfz","messageText":"signin_messageText__7XXhl"};